import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getEvents } from '../../services/apiClient';
import type { Event } from '../../types';
import { formatDateRange } from '../../lib/formatting';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { EmptyState } from '../../components/ui/EmptyState';
import styles from './EventsPage.module.css';

export function EventsPage() {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEvents().then((r) => {
      if (r.data) setEvents(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className="container">
          <h1 className={styles.pageTitle}>Events</h1>
          <p className={styles.pageSub}>Upcoming events, tournaments, and programs.</p>
        </div>
      </div>

      <div className="container">
        <div className={styles.list}>
          {loading ? (
            <p className={styles.loading}>Loading events…</p>
          ) : events.length === 0 ? (
            <EmptyState title="No upcoming events" description="Check back soon for new events." />
          ) : (
            events.map((event) => (
              <Link key={event.id} to={`/events/${event.slug}`} className={styles.eventRow}>
                <div className={styles.eventInfo}>
                  <div className={styles.eventMeta}>
                    <span className={styles.eventType}>{event.type}</span>
                    <StatusBadge label={event.status} />
                  </div>
                  <h2 className={styles.eventTitle}>{event.title}</h2>
                  <p className={styles.eventDate}>{formatDateRange(event.start_date, event.end_date)}</p>
                  <p className={styles.eventLocation}>{event.location}</p>
                </div>
                {event.registration_open && (
                  <span className={styles.regBadge}>Registration Open</span>
                )}
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
